import React from 'react';
import TimeLineItem from './TimeLineItem';
export default class TimeLine extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    /*


     */
    return (

      <ol className="timeline timeline--summary">
        {this.props.items.map((item, index) => {
          return <TimeLineItem key={index}
                              last={index >= (this.props.items.length -2)}
                              item={item}
                              active={this.props.active}
                              handleClick={this.props.onClick}
                              main={this.props.main} />
        })}
      </ol>

    )
  }
};



/** WEBPACK FOOTER **
 ** ./client/TimeLine.js
 **/